<template>
  <PostListFilters v-if="filterItems.length" :filters="filterItems" />
  <PostList :sort="sort" :filter="filter" />
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters, mapMutations } from 'vuex';
import PostList from './components/post-list';
import PostListFilters from './components/post-list-filters';
import { socket } from '@/app/app.service';

export default defineComponent({
  /**
   * 属性
   */
  props: {
    sort: {
      type: String,
    },

    filter: {
      type: Object,
    },
  },

  title() {
    let title;

    if (this.$route.name === 'postIndexPopular') {
      title = '热门节点';
    } else {
      title = '节点';
    }

    return title;
  },

  created() {
    socket.on('userLikePostCreated', this.onUserLikePostCreated);
    socket.on('userLikePostDeleted', this.onUserLikePostDeleted);
    socket.on('commentCreated', this.onCommentCreated);
    socket.on('commentDeleted', this.onCommentDeleted);
  },

  unmounted() {
    socket.off('userLikePostCreated', this.onUserLikePostCreated);
    socket.off('userLikePostDeleted', this.onUserLikePostDeleted);
    socket.off('commentCreated', this.onCommentCreated);
    socket.off('commentDeleted', this.onCommentDeleted);
  },

  computed: {
    ...mapGetters({
      filterItems: 'post/index/filterItems',
    }),
  },

  methods: {
    ...mapMutations({
      setPostItemTotalLikes: 'post/index/setPostItemTotalLikes',
      setPostItemTotalComments: 'post/index/setPostItemTotalComments',
    }),

    onUserLikePostCreated({ postId, socketId }) {
      if (socket.id === socketId) return;

      this.setPostItemTotalLikes({
        postId,
        actionType: 'increase',
      });
    },

    onUserLikePostDeleted({ postId, socketId }) {
      if (socket.id === socketId) return;

      this.setPostItemTotalLikes({
        postId,
        actionType: 'decrease',
      });
    },

    onCommentCreated({ comment }) {
      this.setPostItemTotalComments({
        postId: comment.post.id,
        actionType: 'increase',
      });
    },

    onCommentDeleted({ comment }) {
      this.setPostItemTotalComments({
        postId: comment.post.id,
        actionType: 'decrease',
      });
    },
  },

  components: {
    PostList,
    PostListFilters,
  },
});
</script>
